import { useEffect, useState } from 'react';
import {
    Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from '../ui/dialog';
import {
    Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../ui/select';
import { Textarea } from '../ui/textarea';
import { Button } from '../ui/button';
import { LEAD_LOST_REASONS } from '../../types/leads.types';

interface LostReasonDialogProps {
    open: boolean;
    leadName?: string;
    busy?: boolean;
    onCancel: () => void;
    onConfirm: (reason: string) => void; // reason = "key" o "key: nota libera"
}

// Chiede il motivo quando un lead passa a "Perso". Obbligatorio scegliere un motivo.
export function LostReasonDialog({ open, leadName, busy, onCancel, onConfirm }: LostReasonDialogProps) {
    const [reason, setReason] = useState('');
    const [note, setNote] = useState('');

    useEffect(() => {
        if (open) { setReason(''); setNote(''); }
    }, [open]);

    const confirm = () => {
        if (!reason) return;
        const full = note.trim() ? `${reason}: ${note.trim()}` : reason;
        onConfirm(full);
    };

    return (
        <Dialog open={open} onOpenChange={(o) => !o && onCancel()}>
            <DialogContent className="max-w-md">
                <DialogHeader>
                    <DialogTitle>Perché è perso{leadName ? ` "${leadName}"` : ''}?</DialogTitle>
                </DialogHeader>

                <div className="space-y-3 py-2">
                    <Select value={reason} onValueChange={setReason}>
                        <SelectTrigger>
                            <SelectValue placeholder="Scegli un motivo..." />
                        </SelectTrigger>
                        <SelectContent>
                            {LEAD_LOST_REASONS.map((r) => (
                                <SelectItem key={r.key} value={r.key}>{r.label}</SelectItem>
                            ))}
                        </SelectContent>
                    </Select>
                    <Textarea
                        placeholder="Dettaglio (facoltativo)..."
                        value={note}
                        onChange={(e) => setNote(e.target.value)}
                        rows={2}
                    />
                </div>

                <DialogFooter>
                    <Button variant="outline" onClick={onCancel} disabled={busy}>Annulla</Button>
                    <Button
                        onClick={confirm}
                        disabled={!reason || busy}
                        className="bg-red-600 hover:bg-red-700"
                    >
                        {busy ? 'Salvataggio...' : 'Segna come perso'}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

export default LostReasonDialog;
